var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _ from 'lodash';
export var buildState = function () {
    return {
        customerInformation: {
            title: null,
            thaiFirstName: null,
            thaiLastName: null,
            enFirstName: null,
            enLastName: null,
            dob: null,
            citizenId: null,
            mobileNumber: null,
            email: null,
            occupation: null,
            province: null,
            postalCode: null,
            bookingPeriod: null,
            responsePeriod: null,
            consentFlag: false,
            partnerConsent: [],
        },
    };
};
export var getters = {
    isPartiallyValidMobileNumber: function (_a) {
        var customerInformation = _a.customerInformation;
        var mobileNumber = customerInformation.mobileNumber;
        if (mobileNumber == null)
            return true;
        var isLengthWithinTen = mobileNumber.length <= 10;
        var isNumeric = /^[0-9]*$/.test(mobileNumber);
        var isEmptyOrStartsWithZero = /^0?$/.test(mobileNumber);
        var isStartsWithValidPrefix = /^0[689][0-9]*/.test(mobileNumber);
        return (isEmptyOrStartsWithZero || isStartsWithValidPrefix) && isLengthWithinTen && isNumeric;
    },
    defaultValue: function (state) {
        return {
            title: _.get(state, 'customerInformation.title'),
            thaiFirstName: _.get(state, 'customerInformation.thaiFirstName'),
            thaiLastName: _.get(state, 'customerInformation.thaiLastName'),
            enFirstName: _.get(state, 'customerInformation.enFirstName'),
            enLastName: _.get(state, 'customerInformation.enLastName'),
            dob: _.get(state, 'customerInformation.dob'),
            citizenId: _.get(state, 'customerInformation.citizenId'),
            mobileNumber: _.get(state, 'customerInformation.mobileNumber'),
            email: _.get(state, 'customerInformation.email'),
            occupation: _.get(state, 'customerInformation.occupation'),
            province: _.get(state, 'customerInformation.province'),
            postalCode: _.get(state, 'customerInformation.postalCode'),
            bookingPeriod: _.get(state, 'customerInformation.bookingPeriod'),
            responsePeriod: _.get(state, 'customerInformation.responsePeriod'),
            consentFlag: _.get(state, 'customerInformation.consentFlag'),
            partnerConsent: _.get(state, 'customerInformation.partnerConsent'),
        };
    },
    getCustomerDetails: function (state) {
        return state.customerInformation;
    },
    getPrefixTitle: function (state) {
        switch (state.customerInformation.title) {
            case '':
                return '';
            case 'นาย':
                return 'mr';
            case 'นาง':
                return 'mrs';
            case 'นางสาว':
                return 'miss';
            default:
                return 'other';
        }
    },
};
export var mutations = {
    saveInputData: function (state, _a) {
        var value = _a.value, key = _a.key;
        state.customerInformation[key] = value;
    },
    saveInputObjectData: function (state, customerInformation) {
        state.customerInformation = customerInformation;
    },
    reset: function (state) {
        state.customerInformation = {
            title: null,
            thaiFirstName: null,
            thaiLastName: null,
            enFirstName: null,
            enLastName: null,
            dob: null,
            citizenId: null,
            mobileNumber: null,
            email: null,
            occupation: null,
            province: null,
            postalCode: null,
            bookingPeriod: null,
            responsePeriod: null,
            consentFlag: false,
            partnerConsent: [],
        };
    },
};
export var actions = {
    updateCustomerInformation: function (_a, _b) {
        var commit = _a.commit;
        var value = _b.value, key = _b.key;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                commit('saveInputData', { value: value, key: key });
                return [2 /*return*/];
            });
        });
    },
    updateCustomerInformationObject: function (_a, customerInformation) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                commit('saveInputObjectData', customerInformation);
                return [2 /*return*/];
            });
        });
    },
    reset: function (_a) {
        var commit = _a.commit;
        commit('reset');
    },
};
export var makeCustomerInformation = function () { return ({
    namespaced: true,
    state: buildState(),
    actions: actions,
    mutations: mutations,
    getters: getters,
}); };
